import {
 Box,
 FormControlLabel,
 FormGroup,
 Switch,
 Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface UserSettingsSwitchesProps {
 lockoutEnabled: boolean;
 twoFAEnabled: boolean;
 onLockoutToggle: (checked: boolean) => void;
 onTwoFAToggle: (checked: boolean) => void;
 disabled?: boolean;
}

export const UserSettingsSwitches = ({
 lockoutEnabled,
 twoFAEnabled,
 onLockoutToggle,
 onTwoFAToggle,
 disabled = false,
}: UserSettingsSwitchesProps) => {
 const { t } = useTranslation();

 const settingsSwitches = [
  {
   key: 'lockout',
   checked: lockoutEnabled,
   onToggle: onLockoutToggle,
   labelKey: 'user.sidebar.settings.blockUserFor100Years',
   ariaLabelKey: 'user.sidebar.settings.toggleLockoutAriaLabel',
  },
  {
   key: 'twoFA',
   checked: twoFAEnabled,
   onToggle: onTwoFAToggle,
   labelKey: 'user.sidebar.settings.twoFactorEnabled',
   ariaLabelKey: 'user.sidebar.settings.toggleTwoFactorAriaLabel',
  },
 ];

 return (
  <Box sx={{}}>
   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, pb: 1 }}>
    <Typography
     sx={{
      fontSize: 14,
      fontWeight: 500,
      color: (theme) => theme.palette.kemek.darkGray,
     }}
    >
     {t('user.settings')}
    </Typography>
   </Box>
   <Box
    sx={{
     border: '1px solid',
     borderColor: (theme) => theme.palette.kemek.lightestGray,
     borderRadius: '4px',
     px: '12px',
     py: 1,
    }}
   >
    <FormGroup>
     {settingsSwitches.map(
      ({ key, checked, onToggle, labelKey, ariaLabelKey }) => (
       <FormControlLabel
        key={key}
        labelPlacement="start"
        sx={{ ml: 0, justifyContent: 'space-between' }}
        control={
         <Switch
          checked={checked}
          onChange={(e) => onToggle(e.target.checked)}
          disabled={disabled}
          aria-label={t(ariaLabelKey)}
         />
        }
        label={<Typography sx={{ fontSize: 12 }}>{t(labelKey)}</Typography>}
       />
      ),
     )}
    </FormGroup>
   </Box>
  </Box>
 );
};
